<div class="container" [class.rtl]="layoutService.websiteDirection$.value === 'rtl'">
  <div class="flex justify-flex-start align-center w-100">
    <div class="info">
      <app-icon [name]="data?.icon " type="MaterialDesign" class="icon"></app-icon>
      <div class="flex column justify-flex-start align-items-start">
        <span [innerHTML]="data?.message"></span>
        <a target="_blank" *ngIf="data?.url" [href]="data?.url">{{ data?.urlText ? data?.urlText : data?.url }}</a>
      </div>
    </div>
    <button
      mat-button
      *ngIf="data?.button"
      class="extra-button flex box gaps-1 align-center justify-center text-white"
      [ngClass]="data.button.classes"
      (click)="onButtonClick()"
      matTooltip="{{ data.button.tooltip }}"
      matTooltipPosition="above"
    >
      <app-icon *ngIf="data.button.icon" size="sm" [name]="data.button.icon?.name" [type]="data.button.icon?.type"></app-icon>
      <span *ngIf="data.button.name">{{ data.button.name }}</span>
    </button>
  </div>
  <div class="close-button">
    <app-icon name="close" type="MaterialDesign" class="icon" (click)="snackBarRef.dismiss()"></app-icon>
  </div>
</div>
